import { css, keyframes } from "@emotion/react";
import styled from "@emotion/styled";

const StyledText = styled.span<{ $animate: boolean }>`
  font-size: ${(p) => p.theme.text.fontSizes.m};
  font-weight: 500;
  color: ${(p) => p.theme.text.colors.secondary};

  span {
    display: inline-block;
    animation: ${(p) =>
      p.$animate
        ? css`
            ${keyframes`
            0% { color: ${p.theme.text.colors.primary}; }
            50% { color: ${p.theme.text.colors.primary}77; }
            100% { color: ${p.theme.text.colors.primary}; }
          `} 1800ms infinite ease-in-out;
          `
        : "none"};
  }

  &:hover {
    span {
      animation: none;
      color: ${(p) => p.theme.text.colors.primary};
    }
  }
`;

const Word = styled.span`
  display: inline-block;
  white-space: nowrap;
`;

export const FadingText = ({
  text,
  animate,
}: {
  text: string;
  animate: boolean;
}) => {
  const words = text.split(" ");

  return (
    <StyledText aria-label={text} $animate={animate}>
      {words.map((word, wordIndex) => {
        const charOffset =
          words.slice(0, wordIndex).reduce((sum, w) => sum + w.length, 0) +
          wordIndex;
        return (
          <Word key={wordIndex}>
            {word.split("").map((char, charIndex) => (
              <span
                key={charIndex}
                style={{ animationDelay: `${(charOffset + charIndex) * 0.2}s` }}
              >
                {char}
              </span>
            ))}
            {wordIndex < words.length - 1 && "\u00A0"}
          </Word>
        );
      })}
    </StyledText>
  );
};
